import React from 'react';
import { MdClose } from 'react-icons/md';
import Login from '../Login';

const LoginModal = ({ isOpen, onClose, onLogin }) => {
  if (!isOpen) return null;

  const handleLogin = async (credentials) => {
    try {
      await onLogin(credentials);
      onClose();
    } catch (error) {
      throw error;
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md relative overflow-hidden">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10"
          aria-label="Close"
        >
          <MdClose className="h-6 w-6" />
        </button>
        <Login onLogin={handleLogin} isModal={true} />
      </div>
    </div>
  );
};

export default LoginModal;

